export default __webpack_public_path__ + "resources/icons/n132-3fa7.webp";